function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandStaticSprite = function SvgBrandStaticSprite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden"
  }, props));
};
export { SvgBrandStaticSprite as ReactComponent };
export default __webpack_public_path__ + "static/brand-static-sprite.da7e3fcb.svg";